{
  "action": "İşlem",
  "allSides": "Tüm Yönler",
  "allStatus": "Tüm Durumlar",
  "amount": "Miktar",
  "assetsWallet": "Varlıklar / Cüzdan",
  "available": "Kullanılabilir",
  "availableBalance": "Kullanılabilir Bakiye",
  "baseCurrency": "Temel Para Birimi",
  "buy": "Al",
  "buyExalt": "EXALT Satın Al",
  "buyLong": "Al / Long",
  "buySellTabs": "Al veya Sat",
  "buyToken": "Token Satın Al",
  "cancelOrder": "Emri İptal Et",
  "cancelOrderFailed": "Emir iptali başarısız oldu.",
  "cancelled": "İptal Edildi",
  "cancelledOrders": "İptal Edilen Emirler",
  "change24h": "24S Değişim",
  "close": "Kapat",
  "completed": "Tamamlandı",
  "confirmCancelOrder": "Bu emri iptal etmek istediğinizden emin misiniz?",
  "connectWalletFirst": "Önce cüzdan bağlayın.",
  "cost": "Maliyet",
  "deposits": "Yatırımlar",
  "done": "Tamamlandı",
  "enterAmount": "Miktar Girin",
  "enterPrice": "Fiyat Girin",
  "enterValidAmount": "Lütfen geçerli bir miktar girin.",
  "enterValidPrice": "Lütfen geçerli bir fiyat girin.",
  "exportCsv": "CSV Dışa Aktar",
  "failed": "Başarısız",
  "filled": "Gerçekleşti",
  "filledOrders": "Gerçekleşen Emirler",
  "filtered": "Filtrelendi",
  "hash": "Hash",
  "high24h": "24S En Yüksek",
  "installWallet": "Lütfen MetaMask veya Trust Wallet yükleyin.",
  "instruments": "Enstrümanlar",
  "insufficientBalance": "Yetersiz bakiye.",
  "lastPrice": "Son Fiyat",
  "limit": "Limit",
  "limitOrder": "Limit Emri",
  "limitPrice": "Limit Fiyatı",
  "loadingOrders": "Emirler yükleniyor...",
  "loadingTrades": "İşlemler yükleniyor...",
  "loadingTransactions": "İşlemler yükleniyor...",
  "low24h": "24S En Düşük",
  "manageFutures": "Vadeli İşlemleri Yönet",
  "market": "Piyasa",
  "marketOrder": "Piyasa Emri",
  "marketOrderNotice": "Piyasa emirleri mevcut likiditeye karşı anında gerçekleştirilir. Gerçekleşme fiyatı değişebilir ve gerçekleşmeyen kısım açık kalmaz - hemen iptal edilir.",
  "marketPrice": "Piyasa Fiyatı",
  "mobileTradingChart": "Mobil İşlem Grafiği",
  "moreOptions": "Diğer Seçenekler",
  "noFilledOrders": "Gerçekleşen emir yok.",
  "noOpenOrders": "Açık emir yok.",
  "noOrdersFound": "Emir bulunamadı.",
  "noTradeHistory": "İşlem geçmişi bulunamadı.",
  "noTransactionsFound": "İşlem bulunamadı.",
  "officialExaltContract": "Resmi EXALT Kontratı",
  "open": "Açık",
  "openOrders": "Açık Emirler",
  "orderBook": "Emir Defteri",
  "orderCancelledSuccessfully": "Emir başarıyla iptal edildi.",
  "orderFailed": "Emir başarısız oldu.",
  "orderHistory": "Emir Geçmişi",
  "orderIdMissing": "Emir ID eksik.",
  "orderPlacedSuccessfully": "Emir başarıyla verildi.",
  "orderType": "Emir Türü",
  "pair": "Parite",
  "pending": "Beklemede",
  "placeOrder": "Emir Ver",
  "placingOrder": "Emir veriliyor...",
  "positionHistory": "Pozisyon Geçmişi",
  "price": "Fiyat",
  "processing": "İşleniyor...",
  "quoteCurrency": "Kote Para Birimi",
  "recentTrades": "Son İşlemler",
  "searchMarket": "Piyasa ara...",
  "searchPair": "Parite ara...",
  "searchPairSideStatus": "Parite, yön veya durum ara...",
  "searchTransactions": "İşlemleri ara...",
  "selectPair": "Parite Seç",
  "sell": "Sat",
  "sellExalt": "EXALT Sat",
  "sellShort": "Sat / Short",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "side": "Yön",
  "slPrice": "SL Fiyatı",
  "spotMarkets": "Spot Piyasalar",
  "spotTrading": "Spot İşlem",
  "spotTradingSubtitle": "Exalt Exchange Tarafından Desteklenen Profesyonel Spot İşlem Motoru",
  "status": "Durum",
  "stopLoss": "Zarar Durdur",
  "swapToExalt": "EXALT'a Takas Et",
  "takeProfit": "Kâr Al",
  "token": "Token",
  "total": "Toplam",
  "tpPrice": "TP Fiyatı",
  "tpSl": "TP/SL",
  "tradFi": "TradFi / CFD",
  "tradFiNoProvider": "Henüz bağlı bir CFD/TradFi likidite sağlayıcısı yok.",
  "tradFiNoProviderDescription": "Bu modül sağlayıcıya hazır bir hazırlık mimarisidir. Gerçek bir broker/likidite sağlayıcısı bağlanıp doğrulandığında Forex, Metal, Endeks, Hisse Senedi ve Kripto CFD enstrümanları burada görünecektir.",
  "tradFiStatusUnavailable": "Şu anda TradFi sağlayıcı durumu yüklenemiyor.",
  "tradeHistory": "İşlem Geçmişi",
  "trades": "İşlemler",
  "tradingViewChart": "TradingView Grafiği",
  "transactionHistory": "İşlem Geçmişi",
  "volume24h": "24S Hacim",
  "walletConnected": "Cüzdan başarıyla bağlandı.",
  "walletConnectionFailed": "Cüzdan bağlantısı başarısız oldu.",
  "withdrawal": "Para Çekme",
  "withdrawals": "Çekimler"
}